export const CATEGORIZATION = 'CATEGORIZATION';
export const NODE_COPY = 'NODE_COPY';
export const NODE_CUT = 'NODE_CUT';

export const isCategorize = (directive) => directive === CATEGORIZATION;
export const isPastable = (directive) => [NODE_COPY, NODE_CUT].includes(directive);
